import { Directive, HostListener, Input } from "@angular/core";

@Directive({
	selector: "[bpArrowNav]",
	standalone: false
})
export class BpArrowNavigationDirective {
	@Input() first: boolean = false;
	@Input() last: boolean = false;

	@HostListener("keydown", ["$event"])
	public onKeydownEvent(event: KeyboardEvent | undefined): void {
		const activeEle = document.activeElement;
		if ((event.key === "ArrowLeft" || event.key === "ArrowUp") && !this.first) {
			(activeEle.previousElementSibling as HTMLElement).focus();
		}
		if ((event.key === "ArrowRight" || event.key === "ArrowDown") && !this.last) {
			(activeEle.nextElementSibling as HTMLElement).focus();
		}
	}
}
